/**
 * 字典数据组件（非字典组件）
 * @author xuyd
 * @date 2023-03-01
 */
import Vue from 'vue'
import DictPlugin from './DictPlugin'
import DictOptions from './DictOptions'

function install() {
  Vue.use(DictPlugin, DictOptions)
}

export default {
  install,
}
